import Textarea from '@mui/joy/Textarea';
import { TextareaWrapperProps } from "./ITextareaProps";

const TextareaWrapper = ({ ...props }: TextareaWrapperProps) => {
  return <Textarea {...props} />;
};


export default TextareaWrapper;
